import Gallery1 from "./Gallery1";
import Gallery2 from "./Gallery2";

const gallery = {
    1: Gallery1,
    2: Gallery2
};

export default gallery;